import React, { useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
// Context
// import useCallPerformanceContext from '../context/useCallPerformanceContext';

/* eslint-disable react/prop-types */
export default function ChartReportTable({ loading, data }) {
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'description',
      headerName: 'Mode of Engamentment',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'target',
      headerName: 'No of Engagement',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.target),
    },
    {
      field: 'collection',
      headerName: 'Collection',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.collection),
    },
    {
      field: 'percent_moe',
      headerName: '% of MOE',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        `${Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.percent_moe)}%`,
    },
    {
      field: 'percent_collection',
      headerName: '% of Collection',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        `${Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(
          row.percent_collection,
        )}%`,
    },
  ];

  const pinnedRows = {
    bottom: data?.length ? [data[0]] : [],
  };

  return (
    <div>
      <Box
        className='table-container'
        sx={{
          height: `400px`,
          '& .super-app-theme--header': {
            fontWeight: 'bold',
            backgroundColor: '#6B8D3E',
            color: '#fff',
          },

          '& .moe': {
            backgroundColor: '#cce3f7',
          },

          '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#6B8D3E' },
        }}
      >
        <DataGridPro
          loading={loading}
          rows={data}
          columns={columns}
          sortModel={sortModel}
          experimentalFeatures={{ rowPinning: true }}
          initialState={{
            ...data.initialState,
            pagination: {
              pageSize: 50,
            },
          }}
          pinnedRows={pinnedRows}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          onSortModelChange={(model) => setSortModel(model)}
          getRowClassName={(params) => {
            return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
          }}
        />
      </Box>
    </div>
  );
}
